module.exports = __webpack_public_path__ + "static/media/Coin_Icon.ee1c14bb.png";